import { Component, getAssetPath, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'support-premium-ad-component',
  styleUrl: 'support-premium-ad.scss',
  shadow: true,
})
export class SupportPremiumAd {
  render() {
    return (
      <Host>
        <div class="support-premium-ad">
          <img
            src={getAssetPath('./../assets/icons/support-premium-offer.svg')}
            alt="support-premium offer"
          />
          <div>
            <p>{wcShared?.translate("Besoin d'un support prioritaire 7/7 ?")}</p>
            <a
              href={wcShared?.store?.productsRouting?.website + '/gtl/support-premium.premium'}
              target="_blank"
              rel="noopener, noreferrer"
            >
              {wcShared?.translate("Découvrir l'assistance premium")}
            </a>
          </div>
        </div>
      </Host>
    );
  }
}
